var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
export const RowComponent = (_a) => {
    var { tableRow, selected, onToggle, setSelectedRowData, rowClickHandler, showSelection } = _a, restProps = __rest(_a, ["tableRow", "selected", "onToggle", "setSelectedRowData", "rowClickHandler", "showSelection"]);
    return (React.createElement(Table.Row, Object.assign({}, restProps, { tableRow: tableRow, className: selected && showSelection ? 'table-info' : '', onClick: () => rowClickHandler({
            tableRow,
            toggleSelection: onToggle,
            setSelectedRowData,
        }) })));
};
//# sourceMappingURL=RowComponent.js.map